import { Button } from "../ui/Button";
import type { LoadFormValues } from "./LoadForm";

export interface BoardRow {
  id: string;
  origin: string;
  destination: string;
  linehaulDollars: number;
  miles: number;
  /** Equipment · pickup · broker, when the read has them. */
  detail?: string;
  /** Full form values for this row (deadhead, weight, dims, broker, warnings). */
  form?: LoadFormValues;
}

export function BoardPicker({
  rows,
  onPick,
  onCancel,
}: {
  rows: BoardRow[];
  onPick: (row: BoardRow) => void;
  onCancel: () => void;
}) {
  return (
    <div className="card stack" data-testid="board-picker">
      <strong>Pick from board</strong>
      {rows.length === 0 ? (
        <p className="muted">No board rows yet. Paste a screenshot first.</p>
      ) : (
        rows.map((r) => (
          <button
            key={r.id}
            type="button"
            className="list-item btn-ghost"
            style={{ width: "100%", textAlign: "left" }}
            onClick={() => onPick(r)}
          >
            <span className="stack" style={{ gap: "0.15rem" }}>
              <span>
                {r.origin} → {r.destination}
              </span>
              {r.detail ? <span className="muted" style={{ fontSize: "0.8rem" }}>{r.detail}</span> : null}
            </span>
            <span className="muted">
              ${r.linehaulDollars.toFixed(0)} · {r.miles} mi
            </span>
          </button>
        ))
      )}
      <Button variant="ghost" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  );
}
